import { http } from '@/core/helpers/http.helper';
import { LocationQuery } from 'vue-router';
import { TargetGroupFilter } from './target-group-filter.interface';

export class TargetGroupFilterService {
   async getTargetGroupFilters(query?: LocationQuery) {
      const response = await http.get(`/target-group-filters`, { params: { ...query } });
      return response.data;
   }

   async getTargetGroupFilter() {
      throw Error('Method not implemented');
   }

   async postTargetGroupFilter(targetGroupFilter: TargetGroupFilter) {
      const response = await http.post(`/target-group-filters`, targetGroupFilter, {
         params: { withTranslations: true },
      });
      return response.data;
   }

   async putTargetGroupFilter(targetGroupFilter: TargetGroupFilter) {
      const response = await http.put(`target-group-filters/${targetGroupFilter.id}`, targetGroupFilter, {
         params: { withTranslations: true },
      });
      return response.data;
   }

   async deleteTargetGroupFilter(targetGroupFilterId: number) {
      const response = await http.delete(`target-group-filters/${targetGroupFilterId}`);
      return response.data;
   }
}
